module.exports = "<div class=\"content\">\n\t<div class=\"error-message\">\n\t\t<h2>404</h2>\n\t\t<span class=\"error-sub\">UH OH! We Couldn't Find That Page</span>\n\t\t<div class=\"btn-action\">\n\t\t\t<button mat-button type=\"button\" routerLink=\"/enroll\" class=\"btn-block btn-green mat-button\">Go Back Home</button>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found/page-not-found.component.html
// module chunks = main